import { useTranslation } from 'react-i18next';
import { usePageMeta } from '@/hooks/usePageMeta';
import { getNotFoundPageMeta } from '@/seo/meta';

export default function NotFound() {
  const { t } = useTranslation();
  usePageMeta(getNotFoundPageMeta('/404'));

  return (
    <div>
      <h1>404</h1>
      <p>{t('notFound.pageTitle')}</p>
      <p>{t('notFound.description')}</p>
    </div>
  );
}
